import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';

export interface InitiateMeetTerriDto {
  phone_number: string;
}

export interface InitiateMeetTerriResponse {
  success: boolean;
  message: string;
  call_id?: string;
  session_token?: string;
}

export const useInitiateMeetTerri = () => useMutation({
  mutationFn: async (data: InitiateMeetTerriDto) => 
  // This is a public endpoint, so we don't need authentication
    handleApiCall<InitiateMeetTerriResponse, InitiateMeetTerriDto>(
      null, // No session required for public endpoint
      'POST',
      'meet-terri/initiate',
      data
    )
  ,
});